<script setup lang="ts">
import { PropType, computed } from 'vue';
import { IColumn } from '@/stores/core/models';

const emit = defineEmits(['after-navigate']);
const props = defineProps({
  column: {
    type: Object as PropType<IColumn>,
    required: true,
  },
  row: {
    type: Object,
    required: true,
  },
  isActive: {
    type: Boolean,
  },
  truncateWidth: {
    type: Number,
  },
  customClass: {
    type: String,
    default: '',
  },
  detailsRouteName: {
    type: String,
    required: true,
  },
  detailsRouteIdParamName: {
    type: String as PropType<'id' | 'id2' | 'id3'>,
    default: 'id',
  },
});

const navigateToDetailsRoute = (navigate: Function, event: any) => {
  navigate(event).then(() => emit('after-navigate'));
};

const style = computed(() => {
  return {
    maxWidth: props.truncateWidth ? props.truncateWidth + 'px' : 'unset',
  };
});
</script>
<template>
  <div class="font-medium" :class="{ 'container-table-is-active': isActive, [customClass]: !!customClass }">
    <router-link
      v-slot="{ href, navigate }"
      :to="{
        name: detailsRouteName,
        params: { [detailsRouteIdParamName]: row[column.detailsRouteParamField] },
      }"
      custom
    >
      <a :href="href" @click="navigateToDetailsRoute(navigate, $event)" class="!p-0 !m-0">
        <div
          class="cursor-pointer truncate font-semibold hover:underline hover:text-blue-700 dark:hover:text-blue-600"
          :style="style"
        >
          <span v-if="!!column.formatField">
            {{ column.formatField(row) }}
          </span>
          <span v-else>
            {{ row[column.field as string] }}
          </span>
        </div>
      </a>
    </router-link>
  </div>
</template>
